import React from 'react'

const Vector = props => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9015 1.97033L10.9798 0.850113C10.8529 0.695675 10.6317 0.695917 10.5051 0.850113L9.58321 1.97033C9.51974 2.04743 9.48473 2.1499 9.48493 2.2589C9.48493 2.36766 9.51994 2.47014 9.58321 2.54675L9.93872 2.97865L1.85039 12.8042L1.49468 12.372C1.36795 12.2186 1.14752 12.2183 1.02039 12.3723L0.0982791 13.493C0.0348155 13.5698 0 13.6723 0 13.7811C0 13.8898 0.0348155 13.9923 0.0982791 14.0692L1.02039 15.1894C1.08386 15.2662 1.16801 15.3088 1.25773 15.3088C1.34746 15.3088 1.43161 15.2662 1.49488 15.1894L2.41719 14.0689C2.5475 13.9099 2.5475 13.6515 2.41699 13.4927L2.06128 13.0606L10.1496 3.23484L10.5051 3.66673C10.5684 3.74383 10.6527 3.78612 10.7425 3.78612C10.832 3.78612 10.9163 3.74383 10.9796 3.66673L11.9011 2.54699C11.9648 2.4699 12 2.36742 12 2.25842C12.0002 2.14942 11.965 2.04695 11.9015 1.97033ZM2.20611 13.813L1.2838 14.9332C1.26589 14.9554 1.24938 14.9549 1.23127 14.9332L0.30936 13.813C0.297026 13.7978 0.297026 13.7644 0.30936 13.7492L1.23108 12.6287C1.24023 12.6178 1.25057 12.6154 1.25773 12.6154C1.2649 12.6154 1.27504 12.6178 1.28399 12.6285L2.20611 13.7492C2.22043 13.7666 2.22023 13.7953 2.20611 13.813ZM11.6906 2.29032L10.7689 3.41054C10.7504 3.43302 10.7343 3.43229 10.7162 3.41054L9.79389 2.29008C9.78494 2.27945 9.78315 2.26688 9.78315 2.25866C9.78315 2.24996 9.78494 2.23764 9.79409 2.22652L10.7162 1.1063C10.7254 1.09542 10.7355 1.09301 10.7427 1.09301C10.7496 1.09301 10.7598 1.09518 10.7689 1.1063L11.6908 2.22676C11.7 2.23764 11.702 2.24996 11.702 2.25842C11.7018 2.26688 11.6998 2.27921 11.6906 2.29032Z"
        fill="black"
      />
    </svg>
  )
}

export default Vector



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/vector.js